const baseTheme = {
  colors: {
    primary: '#003B5C',
    secondary: '#0268FF',
    yellow: '#FDE3EC',
  },

  neutrals: {
    50: '#f9fafb',
    100: '#f1f5f9',
    200: '#e5e7eb',
    300: '#d1d5db',
    700: '#374151',
  },
};

export default baseTheme;
